import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "title-section__title" }
const _hoisted_2 = { class: "book-reading__content-editor" }
const _hoisted_3 = { class: "discussion__start-btn-box discussion__show-m" }
const _hoisted_4 = { class: "filter-box filter-box--hide-m" }
const _hoisted_5 = { class: "filter-box__flex-box" }
const _hoisted_6 = { class: "filter-box__form-box" }
const _hoisted_7 = { class: "filter-box__form" }
const _hoisted_8 = { class: "filter-box__btn-box discussion__hide-m" }
const _hoisted_9 = { class: "discussion-list" }

import { onBeforeMount, ref } from 'vue'
import type { Raw } from 'vue'
import { useRouter } from 'vue-router'

import DocLayout from '@/app/components/doc/Layout.vue'
import Footer from '@/app/components/Footer.vue'
import CommunitySearch from '@/app/components/community/Search.vue'
import ThreadListItem from '@/app/components/community/ThreadListItem.vue'
import EOCButton from '@/app/components/billing/EOCButton.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { ForumView } from '@/models/forum'
import type { DocView } from '@/models/doc'
import { assertNotNull } from '@/helpers/typing'


export default /*@__PURE__*/_defineComponent({
  __name: 'Community',
  props: {
    doc: {}
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

const isLoading = ref(true)
const forum = ref<Raw<ForumView> | null>(null)

onBeforeMount(async () => {
  await loadForum()
})

async function loadForum(): Promise<void> {
  try {
    isLoading.value = true
    const response = await backend.getForum(props.doc.forum_id)
    forum.value = new ForumView(response, props.doc)
    isLoading.value = false
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      // Redirect to the non-existing page
      router.push({ name: 'not_found' })
    } else {
      Sentry.captureException(error)
      throw error
    }
  }
}

async function updateToggle(value: boolean): Promise<void> {
  await assertNotNull(forum.value).toggleNotifyNewThread(value)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isLoading.value && forum.value)
    ? (_openBlock(), _createBlock(DocLayout, {
        key: 0,
        class: "layout--topbar",
        doc: __props.doc,
        "show-text-controls": false
      }, {
        "page-title": _withCtx(() => [
          _createElementVNode("h1", _hoisted_1, "Discussion · " + _toDisplayString(forum.value.title), 1)
        ]),
        "page-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!__props.doc.isCommunityEOC)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {
              name: __props.doc.routeNames().edit_thread,
            },
                    class: "btns discussion__start-btn"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "iconfont iadd-comment" }, null, -1),
                      _createTextVNode(" Start discussion ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("form", _hoisted_7, [
                    _createVNode(CommunitySearch, {
                      forum: forum.value,
                      class: "keywords--half"
                    }, null, 8, ["forum"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  (!__props.doc.isCommunityEOC)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                  name: __props.doc.routeNames().edit_thread,
                },
                        class: "btns btns--large filter-box__btn btns--add iconfont iadd"
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" Create Discussion ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode(ToggleButton, {
              class: "discussion-toggle",
              value: forum.value.notify_new_thread,
              "onUpdate:value": updateToggle
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Notify me of new discussions for this book ", -1)
              ]))]),
              _: 1
            }, 8, ["value"]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(forum.value.threads, (thread) => {
                return (_openBlock(), _createBlock(ThreadListItem, {
                  key: thread.id,
                  thread: thread,
                  doc: __props.doc
                }, null, 8, ["thread", "doc"]))
              }), 128)),
              (__props.doc.isCommunityEOC)
                ? (_openBlock(), _createBlock(EOCButton, {
                    key: 0,
                    text: "Start Free Trial to Unlock",
                    "ios-text": "Full Subscription Required to Access Discussions "
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(Footer)
        ]),
        _: 1
      }, 8, ["doc"]))
    : _createCommentVNode("", true)
}
}

})